class ModalScroll {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    const scrollBtn = $(".c-modal-close, .js-voice-modal-overlay, .js-voice-modal-close");
    const scrollInner = $(".modal-inner");

    // スクロールして上に戻る
    scrollBtn.on('click', function (e) {
      setTimeout(function(){
        e.preventDefault();
        scrollInner.animate({ scrollTop: 0 }, 100);
      },200);
    });
  }
}